<template>
  <div ref="previewContainer">
    <v-skeleton-loader v-if="!imageSrc" class="responsive" type="image" />

    <v-fade-transition>
      <img
        v-if="imageSrc"
        class="d-block responsive"
        :src="imageSrc"
        alt="PDF Preview"
      />
    </v-fade-transition>

    <canvas ref="hiddenCanvas" v-show="false"></canvas>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist";
import { openDB } from "idb";

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    imageSrc: null,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
    observer: null,
    dbPromise: null,
  }),
  async mounted() {
    this.dbPromise = openDB("pdf-cache-v1", 1, {
      upgrade(db) {
        db.createObjectStore("thumbnails");
      },
    });

    this.initObserver();
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
    if (this.imageSrc) URL.revokeObjectURL(this.imageSrc);
  },
  methods: {
    initObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.loadThumbnail();
            this.observer.disconnect();
          }
        },
        { rootMargin: "100px" },
      );

      this.observer.observe(this.$refs.previewContainer);
    },
    async loadThumbnail() {
      const db = await this.dbPromise;

      // 1. Tenta Cache
      const cachedBlob = await db.get("thumbnails", this.id);
      if (cachedBlob) {
        this.imageSrc = URL.createObjectURL(cachedBlob);
        return;
      }

      try {
        // REMOVIDO: const pdfjsLib = window["pdfjs-dist/build/pdf"];
        // Agora usamos diretamente o pdfjsLib que você importou no topo do script

        const loadingTask = pdfjsLib.getDocument({
          url: this.url,
          disableAutoFetch: true, // Performance: Não baixa o PDF inteiro se o server aceitar range
          disableStream: true,
        });

        const pdf = await loadingTask.promise;
        const page = await pdf.getPage(1);

        const canvas = this.$refs.hiddenCanvas;
        const context = canvas.getContext("2d");

        // 0.4 de scale costuma ser suficiente para thumbnails
        const viewport = page.getViewport({ scale: 0.4 });

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Renderização
        await page.render({ canvasContext: context, viewport }).promise;

        // Salva no Cache e exibe
        canvas.toBlob(
          async (blob) => {
            if (blob) {
              await db.put("thumbnails", blob, this.id);
              this.imageSrc = URL.createObjectURL(blob);
            }
          },
          "image/webp",
          0.8,
        );

        // Limpeza de memória: Destrói a instância do PDF após o uso
        pdf.destroy();
      } catch (error) {
        console.error("Erro ao gerar preview:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.responsive {
  aspect-ratio: 16 / 9;
  height: auto !important;
  object-fit: cover;
  object-position: top;
  width: 100%;
}
</style>
